// extracted by mini-css-extract-plugin
export default {"productGrid":"C0-z","centerLink":"D0-z","productSection":"E0-z","item":"F0-z","ctaButton":"G0-z"};